import { Pipe, PipeTransform } from '@angular/core';
import { IdName } from '../../models';
import { enumToList } from '../enum-to-list';
import { GoalStatus } from '../../enums/goal-status';

@Pipe({
  name: 'goalStatus',
  standalone: false
})
export class GoalStatusPipe implements PipeTransform {
  public transform(value: GoalStatus): string {
    return getGoalStatus(value);
  }
}

export function getGoalStatus(value: GoalStatus): string {
  switch (value) {
    case GoalStatus.OnTrack:
      return 'On Track';
    case GoalStatus.Behind:
      return 'Behind';
    case GoalStatus.Completed:
      return 'Completed';
    default:
      throw new Error(`Unsupported value for GoalStatus: ${value}.`);
  }
}

export function getGoalStatusList(): IdName[] {
  return enumToList(GoalStatus, getGoalStatus);
}
